<template>
  <div class="boss-layout-block-large hide-for-print">
    <accordion :is-open="true">
      <template #head>
        メッセージ作成
      </template>
      <template #body>
        <slot />
      </template>
    </accordion>
  </div>
</template>

<script>
import Accordion from '@/components/atoms/Accordion'

export default {
  components: {
    Accordion
  }
}
</script>
